<template>
  <div class="space-y-5">
    <div class="flex items-start gap-3">
      <LumiIcon name="done" class="h-6 w-6 flex-shrink-0 text-success-text" />
      <div>
        <h3 class="text-lg font-semibold text-heading">{{ t('onboarding.wizard.finish.title') }}</h3>
        <p class="text-sm text-body mt-1">{{ t('onboarding.wizard.finish.body') }}</p>
      </div>
    </div>

    <!-- Next step after setup: invite the team from the admin area. -->
    <div class="rounded-lg border border-default bg-surface-wash p-4">
      <p class="text-sm font-medium text-heading">{{ t('onboarding.wizard.finish.nextTitle') }}</p>
      <p class="text-sm text-body mt-1">{{ t('onboarding.wizard.finish.nextBody') }}</p>
    </div>

    <!-- Demo path: finishing wipes the demo AND any invited users (ADR 0032 / issue 214). -->
    <div v-if="isDemo" class="rounded-lg border border-warning-soft bg-warning-soft px-4 py-3 text-sm text-warning-text">
      {{ t('onboarding.wizard.finish.demoWarning') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { LumiIcon } from '@lumi/ui';
import { useOnboardingStore } from '../../stores/onboarding';

// Final wizard step (issue 214): a congrats/next-steps screen. It stages nothing — the
// footer's "finish" action commits (wipe-if-demo → replay). Reachable directly via
// the Finish stepper bubble so users can jump straight to it.
const { t } = useI18n();
const onboardingStore = useOnboardingStore();
const isDemo = computed(() => onboardingStore.isDemo);
</script>
